<ng-container *transloco="let t;">
    <div class="modal-header">
        <h4 class="modal-title"
            id="myModalLabel1">{{ t('Save filters modal title (save filters modal) - Save filter') }}</h4>
        <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <form [formGroup]="newFilterForm" class="editable" (ngSubmit)="onAddFilterClick()">
        <div class="modal-body" tabindex="0">
            <div class="saveFiltersWrapper">
                <div class="row">
                    <div class="col-8">
                        <div class="form-group mb-0">
                            <label class="form-label mb-0">{{ t('Name field (saved filters modal) - name') }}</label>
                            <input type="text" formControlName="name" [placeholder]="t('Name field (saved filters modal) - name')" class="form-control mb-0"/>
                        </div>

                    </div>
                    <div class="col-4">
                        <div class="custom-control custom-control-primary custom-switch mt-25">
                            <p class="mb-75 font-small-3">{{ t('Make public field (saved filters modal) - make public') }}</p>
                            <input type="checkbox"
                                    id="is_public_new"
                                    class="custom-control-input"
                                    [formControl]="newFilterForm.controls.public"/>
                            <label class="custom-control-label" for="is_public_new"></label>
                          </div>                        
                    </div>
                    <div class="row">
                        <div class="col-8">
                            <div *ngIf="newFilterForm && newFilterForm.touched && newFilterForm.invalid"
                                 class="invalid-feedback"
                                 [ngClass]="{ 'd-block': newFilterForm.invalid }">
                                <div *ngIf="newFilterForm.controls.name.hasError('required')">
                                    {{
                                        t('Field required (form validation) - Field name is required', {
                                            fieldName: t('Name field (saved filters modal) - name')
                                        })
                                    }}
                                </div>
                                <div *ngIf="newFilterForm.controls.name.hasError('minlength')">
                                    {{ t('Minimal length (validation message) Minimal length is', {min: newFilterForm.controls.name.getError('minlength')?.requiredLength}) }}
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </div>
        </div>


        <div class="modal-footer">
            <button [disabled]="saveFilterInProgress" type="submit" class="btn btn-primary mx-0" rippleEffect>
                {{ t("Save button text (save button) - save") }} <span *ngIf="saveFilterInProgress"
                                                                       class="spinner-border spinner-border-sm ms-50"></span>
            </button>
        </div>
    </form>
</ng-container>
